Ext.define('SA.VectorMapThematicMapRequestTransformFunction', {
    singleton: true,

    get(styleBaseUrls) {
        return url => ({url: url.replace(/^(\w[\w\d.-]*):\/\//, (protocol, scheme) => styleBaseUrls[scheme] ?? protocol)});
    }
});